import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl,Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import { ToastService } from 'src/app/core/services/misc/toast.service';

@Component({
  selector: 'app-differential-diagnosis',
  templateUrl: './differential-diagnosis.component.html',
  styleUrls: ['./differential-diagnosis.component.scss']
})
export class DifferentialDiagnosisComponent implements OnInit {
  differential_diagnosis_form = new FormGroup({
    name: new FormControl('', Validators.compose([ Validators.required,])),
    remarks: new FormControl(''),
    date: new FormControl(''),

  });

  constructor(
    private matDialogRef: MatDialogRef<any>,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
  }

  save() {
    if(this.differential_diagnosis_form.value.name){
      const object = this.differential_diagnosis_form.value;
      object.is_default = false
      object.selected = true
      this.matDialogRef.close(object);
    }else{
      this.toast.showError('Please Enter Name');
    }

  }
}
